import React, { useState, useEffect } from 'react'
import RouteMap from 'assets/RouteMap'
import CollectionHandler from 'assets/CollectionHandler.js'
import SkillsAndHobbiesProfileView from './SkillsAndHobbiesProfileView'
import ExperienceHelper from 'assets/ExperienceHelper'

const SkillsAndHobbiesProfile = (props) => {
    const {
        disabledSave,
        disabledPaper,
        condensed,
        setStudentSkillsAndHobbies,
        studentSkillsAndHobbies,
        setExperienceIsUpdated,
        black, inputRefs, errors,
        highlightInputField,
        withCondensedStyle
    } = props

    const highSchoolStudyTypeCollection = CollectionHandler.Get('highSchoolStudyTypeCollection')
    const schoolCollection = CollectionHandler.Get('schoolCollection')
    const studyFieldCollectionExcludeOutdated = CollectionHandler.Get('studyFieldCollectionExcludeOutdated')

    useEffect(() => {
        ExperienceHelper.AddOtherToCollection(studyFieldCollectionExcludeOutdated)
        ExperienceHelper.AddOtherToCollection(schoolCollection)
    }, [])

    const addNewSkill = () => {
        setStudentSkillsAndHobbies([...studentSkillsAndHobbies])
    }

    const handleChangeSkill = (index, prop) => (event) => {
        setExperienceIsUpdated(true)
        studentSkillsAndHobbies[index][prop] = event.target.value
        setStudentSkillsAndHobbies([...studentSkillsAndHobbies])
    }

    return (
        <SkillsAndHobbiesProfileView
            black={black}
            disabledPaper={disabledPaper}
            addNewSkill={addNewSkill}
            disabledSave={disabledSave}
            condensed={condensed}
            handleChangeFormation={handleChangeSkill}
            highSchoolStudyTypeCollection={highSchoolStudyTypeCollection}
            schoolCollection={schoolCollection}
            setStudentSkillsAndHobbies={setStudentSkillsAndHobbies}
            studentSkillsAndHobbies={studentSkillsAndHobbies}
            studyFieldCollection={studyFieldCollectionExcludeOutdated}
            inputRefs={inputRefs}
            errors={errors}
            highlightInputField={highlightInputField}
            withCondensedStyle={withCondensedStyle}
        />
    )
}
export default SkillsAndHobbiesProfile
